module.exports = __webpack_public_path__ + "/images/constructor-hiw.fr.ae342a5.jpg";